<template>
  <div class="locations-offer flex flex-space-between flex-align-items-center">
    <div class="locations-offer-wrapper">
      <h2 class="vz-text-align-left">Мы предлагаем:</h2>
      <div v-for="item, index of items" :key="index" class="locations-offer-item mb-20">
        <vz-icon
          :url="item.icon"
          variant="primary"
          no-masked-icon
        />
        <span class="ml-10 text-bold">{{ item.title }}</span>
      </div>
      <public-text-warning class="mt-10">
        Также для наших клиентов доступна услуга «Ответственное хранение»
      </public-text-warning>
    </div>
    <locations-offer-tariff :region="region" />
  </div>
</template>

<script setup lang="ts">
import PublicTextWarning from '~/components/public/public-text-warning.vue'
import LocationsOfferTariff from '~/components/public/locations/locations-offer/locations-offer-tariff.vue'
import {LocationRegion} from '~/types/types'

const props = defineProps({
  region: {
    type: Object as PropType<LocationRegion>,
    default: () => {}
  },
})

const items = [
  {
    icon: '/svg/stock.svg',
    title: 'Межтерминальную доставку',
  }, {
    icon: '/svg/marker.svg',
    title: 'Адресную доставку',
  }, {
    icon: '/svg/package.svg',
    title: 'Упаковку грузов',
  }, {
    icon: '/svg/shield.svg',
    title: 'Страхование грузов',
  }
]
</script>

<style lang="scss" scoped>
.locations-offer {
  @media only screen and (max-width: $pub-xs) {
    margin-top: 70px;
    flex-direction: column;
  }

  &-wrapper {
    @media only screen and (max-width: $pub-xs) {
      margin-bottom: 40px;
    }
  }

  &-item {
    display: flex;
    align-items: center;
  }
}
</style>